import { Component, Input, OnInit } from '@angular/core';
import { FormDomainScriptGuideService } from '../../form-domain-script-guide.service';
import {
    FormDomainScriptGuidePageAssistService,
} from '@client/app/forms/domain-script-guide/features/page-assist/form-domain-script-guide-page-assist.service';

@Component({
    selector: 'form-domain-script-guide-legacy-page-assist',
    standalone: false,
    templateUrl: './page-assist.html',
})
export class FormDomainScriptGuideLegacyPageAssistComponent implements OnInit {
    @Input() prefixName?: string;
    @Input() domain: any;
    @Input() pageAssistModel: any;

    settingEnabled: boolean = false;

    constructor (
        private formDomainScriptPageAssistService: FormDomainScriptGuidePageAssistService,
        private formDomainScriptGuideService: FormDomainScriptGuideService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.settingEnabled = this.pageAssistModel.getIsEnabled();
    }

    onEnabledChange () {
        setTimeout(() => {
            this.pageAssistModel.settings.enabled = this.settingEnabled;
            this.pageAssistModel.legacySettings.enabled = this.settingEnabled;
            this.updateDomainSettings();
        });
    }

    updateDomainSettings () {
        setTimeout(() => {
            this.formDomainScriptGuideService.setPageAssistEdit(this.pageAssistModel);
        });
    }

    canUseFeature () {
        return this.formDomainScriptPageAssistService.getAccessToFeature(this.domain);
    }
}
